<label *ngFor="let item of dynamicArticles"  class=" is-block mt-2 ml-0 checkbox">
    <input type="checkbox" name="dynamic-article[]" (change)="toggleItem(item.id)" [checked]="isSelected(item.id)">
    {{item.name}}
    <span *ngIf="item.description" class="is-size-7 mt-1 is-block">{{item.description}}</span>
</label>
